import styled from "styled-components";

export const StyledModal = styled.div`
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background-color: #0000003e;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 12;
  overflow: auto;
`;
export const StyledModalContent = styled.div`
  width: 1000px;
  max-width: 90%;
  background-color: ${({ theme }) => theme.colors.neutral00};
  border-radius: 8px;
  position: relative;
  margin: 0 180px;
  ${({ theme }) => theme.mediaWidth.upToLarge`
    margin: 0 24px;
  `}
`;
export const StyledModalHeader = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  text-align: center;
  margin-bottom: 56px;
  padding: 16px 16px 0;
  ${({ theme }) => theme.mediaWidth.upToSmall`
    margin-bottom: 36px;
  `}
`;
export const StyledModalBody = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
`;

export const CloseButton = styled.button`
  display: flex;
  align-items: center;
  padding: 8px;
  background-color: ${({ theme }) => theme.colors.neutral20};
  margin-left: auto;
  border-radius: 4px;
  cursor: pointer;
`;
export const StyledModalFooter = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0 16px 16px;
`;
export const BodyContentWrapper = styled.div`
  padding: 0 16px;
`;
